/* eslint-disable */ //todo: check but probably input will be moved to prime implementation
import { Component, forwardRef, Input, ElementRef, ViewChild, ContentChild, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CwInputComponent),
    multi: true
};

const noop = () => {};

@Component({
    selector: 'cw-input',
    styleUrls: ['./input.component.scss'],
    template: `
        <!-- eslint-disable --> <!-- todo: check but probably input will be moved to prime implementation -->
        <div class="cw-md-input__wrapper"
             [ngClass]="{'cw-md-input--error': !!errors}">
            <input
                #input
                class="cw-md-input"
                [ngClass]="{'state--not-empty': !!model}"
                [(ngModel)]="model"
                [type]="type"
                [readonly]="readonly"
                (blur)="onTouchedCallback()" />
            <label
                class="cw-md-input__label"
                [ngClass]="{'cw-md-label--error': !!errors}"
                (click)="onLabelClick()">{{label}}</label>
            <span
                *ngIf="!!errors"
                class="cw-md-form-error">
                <ng-content selector="[#errors]" />
            </span>
        </div>
    `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
    standalone: false
})
export class CwInputComponent implements ControlValueAccessor {

    @Input('cw-label')
    public label!: string;

    @Input('cw-type')
    public type = 'text';

    @Input('cw-readonly')
    public readonly = false;

    @ContentChild('errors')
    public errors!: ElementRef;

    @ViewChild('input')
    public input!: ElementRef;

    public onTouchedCallback: () => void = noop;
    protected onChangedCallback: (_: any) => void = noop;

    protected _model: any;

    constructor(
        protected cd: ChangeDetectorRef
    ) {}

    public onLabelClick(): void {
        this.input.nativeElement.focus();
    }

    get model(): any {
        return this._model;
    }

    set model(value: any) {
        if (value !== this._model) {
            this._model = value;
            this.onChangedCallback(value);
            this.cd.markForCheck();
        }
    }

    public focus(): void {
        this.input.nativeElement.focus();
    }

    public blur(): void {
        this.input.nativeElement.blur();
    }

    public writeValue(obj: any): void {
        if (obj !== this._model) {
            this._model = obj;
            this.cd.markForCheck();
        }
    }

    public registerOnChange(fn: any): void {
        this.onChangedCallback = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }
}
